import InfoSection from "../components/info_section";
import ScrollButton from "../components/scroll_button";
import Layout from "../components/layout";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import styles from "../styles/terraform.module.scss";
import Image from "next/image";
import Modal from "../components/contactUsModal";
import TerraformDesc from "../public/terraform_desc.webp";
import Code from "../public/terraform_code.webp";
import Support from "../public/terraform_support.webp";

export default function Terraform() {
  const router = useRouter();
  const { t } = useTranslation("terraform");

  const renderServiceOptions = (serviceName, itemsCount) => (
    <div className={styles.service}>
      <h3>{t(`support.${serviceName}`)}</h3>
      <ul>
        {new Array(itemsCount).fill("").map((_, key) => (
          <li key={key}>{t(`support.${serviceName}${key + 1}`)}</li>
        ))}
      </ul>
    </div>
  );

  return (
    <Layout
      title={t("metaTitle")}
      lang={router.locale}
      route={router.route}
      description="terraform.metaDescription"
      isHeader
      isFooter
    >
      <ScrollButton scrollStepInPx="50" delayInMs="16.66" />
      <InfoSection
        title="ICDC’s Terraform Provider"
        description="terraform.description"
        documentationLink="https://registry.terraform.io/providers/icdc-io/icdc/latest/docs"
        lang={router.locale}
      />
      <section className={styles.description}>
        <div className={styles.description__content}>
          <h2>{t("description.title")}</h2>
          <p>{t("description.desc")}</p>
          <p>{t("description.desc2")}</p>
        </div>
        <div className={styles.image}>
          <Image src={TerraformDesc} alt="Terraform" />
        </div>
      </section>

      <section className={styles.benefits}>
        <h2>{t("benefits.title")}</h2>
        <div className={styles.container}>
          {new Array(4).fill("").map((_, key) => (
            <div className={styles.item} key={key}>
              <h3>{t(`benefits.title${key + 1}`)}</h3>
              <p>{t(`benefits.desc${key + 1}`)}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.features}>
        <h2>{t("features.title")}</h2>
        <p className={styles.desc}>{t("features.desc")}</p>
        <div className={styles.container}>
          {new Array(5).fill("").map((_, key) => (
            <div className={styles.item} key={key}>
              <img src={`/icons/terraform_feature${key + 1}.svg`} alt="" />
              <h3>{t(`features.title${key + 1}`)}</h3>
              <p>{t(`features.desc${key + 1}`)}</p>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.code}>
        <div className={styles.code__content}>
          <h2>{t("code.title")}</h2>
          <p>{t("code.desc")}</p>
        </div>
        <div className={styles.image}>
          <Image src={Code} alt="Terrafrom plan" />
        </div>
      </section>

      <section className={styles.support}>
        <div className={styles.container}>
          <div className={styles.desc}>
            <h2>{t("support.title")}</h2>
            <h3>{t("support.desc")}</h3>
          </div>
          {renderServiceOptions("compute", 2)}
          {renderServiceOptions("networking", 5)}
          <h3 className={styles.desc2}>{t("support.desc2")}</h3>
        </div>
        <div className={styles.image}>
          <Image src={Support} alt={t("supportAlt")} />
        </div>
      </section>

      <section className={"flex " + styles.get_started}>
        <h2>{t("get_started.title")}</h2>
        <div className={styles.container}>
          {new Array(3).fill("").map((_, key) => (
            <div key={key} className={styles.item}>
              <h3>{t(`get_started.title${key + 1}`)}</h3>
              <p>{t(`get_started.desc${key + 1}`)}</p>
              <a href={t(`get_started.link${key + 1}`)} className="btn cloud">
                {t(`get_started.button${key + 1}`)}
                {key === 2 && <span className='sr-only'>{t('learn_more_about_terraform')}</span>}
              </a>
            </div>
          ))}
        </div>
      </section>

      <section className={styles.questions}>
        <h2>{t("contact_us.title")}</h2>
        <p>{t("contact_us.desc")}</p>
        <Modal lang={router.locale} blue />
      </section>
    </Layout>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["terraform", "common"])),
  },
});
